import React, { useRef, useState } from "react";
import Filters from "../components/SabeeappBookingList/Filters";
import BookingTable from "../components/SabeeappBookingList/BookingTable";
import { Button } from "../components/Elements";
import SabeeAppIntegrationModal, { SabeeAppIntegrationModalRefProps } from "../components/SabeeappBookingList/SabeeAppIntegrationModal";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const SabeeappBookingList = () => {

  const sabeeAppIntegrationModalRef = useRef<SabeeAppIntegrationModalRefProps>(null);
  const [filtersIsOpen, setFiltersIsOpen] = useState(true);
  const [configurationMissing, setConfigurationMissing] = useState(false);

  const openSabeeAppConfiguration = () => {
    sabeeAppIntegrationModalRef.current?.openModal();
  }

  return (
    <div className="w-full">
      <div className="px-4 py-2 flex flex-col justify-start space-y-2">
        <h1 className="font-bold text-contrast-90 text-2xl px-2">
          Rezervasyon Listesi
        </h1>

        <div className=" flex flex-row justify-between items-center px-2">
          <div className="flex items-start flex-col ">
            <div className="flex items-center mt-2">
              <Button
                size="xs"
                hover="primary"
                color="primary"
                className=""
                callback={openSabeeAppConfiguration}
              >
                <span className="mr-3">SabeeApp Entegrasyon Bilgileri</span>


              </Button>
              {configurationMissing && (
                <FontAwesomeIcon className="text-warning ml-2" size="xl"
                  title="Entegrasyon bilgileriniz eksik. Lütfen doldurun." icon={faCircleExclamation} />
              )}
            </div>
          </div>
          <Button
            size="xs"
            hover="gray"
            color="gray"
            callback={() => setFiltersIsOpen(!filtersIsOpen)}
          >
            <span className="mr-3">Filtreler</span>
            <img src="/icons/filter.svg" alt="filter" />
          </Button>
        </div>
      </div>
      <SabeeAppIntegrationModal ref={sabeeAppIntegrationModalRef} setConfigurationMissing={setConfigurationMissing} />
      <Filters isOpen={filtersIsOpen} setFiltersIsOpen={setFiltersIsOpen} />
      <BookingTable />
    </div>
  );
}
export default SabeeappBookingList;